<template>
  <div class="unit-detail">
    <!-- 基础信息部分 -->
    <headline title="基本信息" class="headline" />
    <el-divider class="base-divider" />
    <el-table class="zwx-table zwx-table-detail" style="width: 100%;" row-key="key" :data="dataList" :show-header="false" border :stripe="false">
      <el-table-column prop="key" width="142" header-align="right" align="right"/>
      <el-table-column prop="value" header-align="left" align="left"/>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'UnitDetail',
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      rid: this.$route.params.rid,
      dataList: [],
    }
  },
  created() {},
  mounted() {
    this.detail()
  },
  computed: {},
  methods: {
    detail() {
      this.$emit('loading', true)
      let data = {
        rid: this.rid,
      }
      this.$system.get(this.api + '/systematic/getUnit-1', data, true, true, this.detailSuccess, this.error)
    },
    detailSuccess(data) {
      if (data.type === '00') {
        this.dataList.push({ key: '地区：', value: data.unit.fkByZoneId.fullName })
        this.dataList.push({ key: '机构名称：', value: data.unit.unitName })
        this.dataList.push({ key: '机构简称：', value: data.unit.unitAbb })
        this.dataList.push({ key: '机构编码：', value: data.unit.unitCode })
        this.dataList.push({ key: '统一社会信用代码：', value: data.unit.socialCode })
        this.dataList.push({ key: '机构类型：', value: data.unit.unitTypeSimpleCode ? data.unit.unitTypeSimpleCode.codeName : '' })
        this.dataList.push({ key: '注册地址：', value: data.unit.unitAddr })
        this.dataList.push({ key: '邮编：', value: data.unit.postCode })
        this.dataList.push({ key: '联系人：', value: data.unit.linkMan })
        this.dataList.push({ key: '联系电话：', value: this.$zwxSm.sm4JsDecrypt(data.unit.linkTel) })
        this.dataList.push({ key: '联系人职务：', value: data.unit.linkDuty })
        this.dataList.push({ key: '负责人：', value: data.unit.chargeMan })
        this.dataList.push({ key: '负责人电话：', value: this.$zwxSm.sm4JsDecrypt(data.unit.chargeTel) })
        this.dataList.push({ key: '负责人职务：', value: data.unit.chargeDuty })
        this.dataList.push({ key: '传真：', value: data.unit.unitFax })
        this.dataList.push({ key: '邮箱：', value: data.unit.unitEmail })
        this.$emit('loading', false)
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    error() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
